import * as _ from 'lodash';
import * as qs from 'query-string';
import * as moment from 'moment';
import { toast } from "react-toastify";
import { Component } from 'react';
import { connect, Dispatch } from 'react-redux';
import { Col, Row, Button, Label, Alert } from 'react-bootstrap';
import { IApplicationState, AppActionCreators, IConfigureMatchRunResponse, MatchingActionCreators, ISubmitMatchRunResponse, IDonorsPerMonthByAboResponse, TargetActionCreators, SwapActionCreators, IGetAllNewResponse } from '@nkr/store/index';
import { IMatchRunRequest, IMiracleMatch, IMatchRunScenario, IEwtSummary, IDonorsPerMonthByAbo, IListItem, IBaseResponse, ITargetItem, IMortalityCalculations } from '@nkr/models/index';
import { ClusterStatus, MatchRunType, TargetCheckTypeNew } from '@nkr/enums/index';
import { ICenterItem, IChainStartItem } from './models';
import { RouteComponentProps } from 'react-router';
import { MatchSetupWrapper } from './styles';
import Config from './config';
import Centers from './centers';
import ChainStarts from './chain-starts';
import EwtDetails from '@nkr/views/target-new/modals/ewt-details';
import { ListType } from '@nkr/views/target-new/list-type';
import MortalityBreakdown from '@nkr/components/mortality-breakdown-modal';

interface IOwnProps extends RouteComponentProps<{}> { }

interface IStateProps {
    clusterStatusList: IListItem[];
}

interface IDispatchProps {
    showLoading: (test: string) => Promise<void>
    hideLoading: () => void,
    configureMatchRun: (targets: string, chainEndTargets: string) => Promise<IConfigureMatchRunResponse>,
    submitMatchRun: (request: IMatchRunRequest) => Promise<ISubmitMatchRunResponse>,
    saveClusterStatus: (clusterId: number, clusterStatus: number) => Promise<IBaseResponse>,
    saveComment: (clusterId: number, comment: string) => Promise<IBaseResponse>,
    getDonorsPerMonthByAbo: () => Promise<IDonorsPerMonthByAboResponse>,
    getAllTargets: () => Promise<IGetAllNewResponse>
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    matchRunType: MatchRunType,
    maxChainDepth: number,
    maxLoopDepth: number,
    isolateDeepestN: number,
    veryLowPmp: number,
    lowPmp: number,
    hlaFloorForAccumulator: number,
    bufferDonorAgeByYears: number,
    bufferHlaMatchPointsByPoints: number,
    useOnlyPreAcceptedDonors: boolean,
    useAllCHIPS: boolean,
    onlyOToO: boolean,
    ignoreBlockAllDonors: boolean,
    returnOnlyOBDs: boolean,
    endOnAboO: boolean,
    centerList: ICenterItem[],
    chainStarts: IChainStartItem[],
    targets: IMiracleMatch[],
    targetList: ITargetItem[],
    targetListType: ListType,
    suppress: boolean,
    checkAllChainStarts: boolean,
    checkAllCenters: boolean,
    originalScenario: IMatchRunScenario,
    scenario: IMatchRunScenario,
    noSelected: boolean,
    uuid: string,
    donorsPerMonthByAbo: IDonorsPerMonthByAbo,
    clusterStatusList: IListItem[],
    ewt: {
        show: boolean,
        ewtSummary: IEwtSummary,
        initialCount: { [key: string]: number, O: number, A: number, B: number, AB: number }
    },
    mortalityBreakdown: {
        show: boolean,
        recipientAlias: string,
        data: IMortalityCalculations
    }
}

const offerMonths = moment.monthsShort().map(x => 'OFFER ' + x.toUpperCase());

const ClearingComment = 'CLEARING';
const OfferComment = 'OFFER';

const CommentSortGroup = {
    Offer: 1,
    OtherOffer: 2,
    Clearing: 3,
    OfferOutsideCurrentMonth: 4
};

const commentSortGroup = (note: string): number => {
    let comment = note.toUpperCase();

    if (comment == OfferComment) {
        return CommentSortGroup.Offer;
    }

    if (comment == ClearingComment) {
        return CommentSortGroup.Clearing;
    }

    if (offerMonths.indexOf(comment) > -1) {
        return CommentSortGroup.OfferOutsideCurrentMonth;
    }

    return CommentSortGroup.OtherOffer;
};

const surgeryDateSortValue = (item: IChainStartItem): number => {
    return moment(item.donor.latestSurgeryDateTime, 'MM/DD/YYYY').valueOf();
};

class ConfigureMatchRun extends Component<TProps, IState> {
    readonly state: IState = {
        matchRunType: MatchRunType.Chains,
        maxChainDepth: 0,
        maxLoopDepth: 0,
        isolateDeepestN: 0,
        veryLowPmp: 0,
        lowPmp: 0,
        hlaFloorForAccumulator: 0,
        bufferDonorAgeByYears: 0,
        bufferHlaMatchPointsByPoints: 0,
        useOnlyPreAcceptedDonors: false,
        useAllCHIPS: false,
        onlyOToO: false,
        ignoreBlockAllDonors: false,
        returnOnlyOBDs: false,
        endOnAboO: false,
        centerList: [],
        chainStarts: [],
        targets: [],
        targetList: [],
        targetListType: null,
        suppress: true,
        checkAllChainStarts: false,
        checkAllCenters: true,
        originalScenario: null,
        scenario: null,
        noSelected: false,
        uuid: '',
        donorsPerMonthByAbo: null,
        clusterStatusList: [],
        ewt: {
            show: false,
            ewtSummary: null,
            initialCount: null
        },
        mortalityBreakdown: {
            show: false,
            recipientAlias: '',
            data: null
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        let parsed = qs.parse(this.props.location.search);
        let targets = parsed.targets != null ? parsed.targets : '';
        let chainEndTargets = parsed.chainEndTargets != null ? parsed.chainEndTargets : '';
        let scenarioId = parsed.scenario != null ? parseInt(parsed.scenario) : 0;
        let uuid = parsed.uuid != null ? parsed.uuid : '';

        this.props.showLoading('Configuring best-match, one moment please...').then(() => {
            this.props.configureMatchRun(targets, chainEndTargets).then(async response => {
                this.props.hideLoading();

                if (response.data.success) {
                    let { settings, chainStarts: chainStartList, targets, centers, scenarios, clusterStatusList } = response.data.results;

                    let originalScenario = scenarios.find(x => x.id == scenarioId);
                    let scenario = scenarios.find(x => x.id == scenarioId);

                    let stalled = scenario != null ? scenario.stalled : false;
                    let loops = scenario != null ? scenario.loops : false;
                    let visible = scenario != null ? scenario.group.visible : false;

                    let centerList: ICenterItem[] = centers.map(center => {
                        return { center, selected: true };
                    });

                    let checkType = scenario != null ? scenario.group.checkType : 0;

                    let chainStarts: IChainStartItem[] = chainStartList.map(donor => {
                        let selected = false;

                        if (checkType == TargetCheckTypeNew.HardToMatch) {
                            selected = donor.cluster.clusterStatusId < ClusterStatus.InProcess;
                        } else {
                            if (scenario.group.future == false) {
                                if (stalled) {
                                    selected = donor.cluster.clusterStatusId == ClusterStatus.Stalled && donor.cluster.note == 'Offer';
                                } else if (!loops) {
                                    selected = donor.cluster.clusterStatusId == ClusterStatus.Offers && donor.cluster.note == 'Offer';
                                }
                            } else {
                                if (stalled) {
                                    selected = donor.cluster.clusterStatusId == ClusterStatus.Stalled && offerMonths.filter(offerMonth => donor.cluster.note.toUpperCase() == offerMonth).length > 0;
                                }
                            }

                            if (visible) {
                                selected = donor.cluster.clusterStatusId <= ClusterStatus.Offers;
                            }
                        }

                        return { donor, selected };
                    });

                    let matchRunType = MatchRunType.Chains;

                    if (loops) {
                        matchRunType = MatchRunType.Loops;
                    }

                    let noSelected = !loops ? chainStarts.filter(x => x.selected).length == 0 : false;

                    if (scenario != null && scenario.submit && noSelected) {
                        scenario = scenarios.find(x => x.group.name == scenario.group.name && x.restricted == -1);
                    }

                    const targetListType = this.getTargetListType(scenario);

                    const [donorsPerMonthByAboResponse, targetsResponse] = await Promise.all([
                        this.props.getDonorsPerMonthByAbo(),
                        targetListType != null ? this.props.getAllTargets() : Promise.resolve<IGetAllNewResponse>(null)
                    ]);

                    const targetList = targetsResponse?.data.success
                        ? this.getTargetList(targetListType, targets, targetsResponse.data.results)
                        : [];

                    this.setState({
                        matchRunType,
                        maxChainDepth: settings.maxChainDepthVal,
                        maxLoopDepth: settings.maxLoopDepthVal,
                        isolateDeepestN: settings.isolateDeepestNVal,
                        veryLowPmp: settings.veryLowPmpVal,
                        lowPmp: settings.lowPmpVal,
                        hlaFloorForAccumulator: settings.cumulativeHlaPointsFloorVal,
                        bufferDonorAgeByYears: settings.bufferDonorAgeByYearsVal,
                        bufferHlaMatchPointsByPoints: settings.bufferHlaMatchPointsVal,
                        useOnlyPreAcceptedDonors: false,
                        useAllCHIPS: settings.chipsIfFncs3IsLessThan1Val,
                        onlyOToO: checkType == TargetCheckTypeNew.HardToMatch ? false : true,
                        ignoreBlockAllDonors: settings.ignoreBlockAllDonorsVal,
                        returnOnlyOBDs: settings.onlyOBds,

                        centerList,
                        chainStarts,
                        targets,
                        targetList,
                        targetListType,

                        originalScenario,
                        scenario,
                        noSelected,

                        uuid,
                        donorsPerMonthByAbo: donorsPerMonthByAboResponse.data.results,
                        clusterStatusList
                    }, () => {
                        if (scenario != null && scenario.submit && this.state.noSelected == false) {
                            this.handleSubmitMatchRun(scenario.restricted == 1);
                        }
                    });
                }
            });
        });
    }

    getChainStarts = () => {
        let chainStarts = this.state.chainStarts.filter(cs => {
            if (this.state.suppress) {
                if (cs.donor.cluster.clusterStatusId > ClusterStatus.Offers) {
                    return false;
                }
            }

            return true;
        });

        let sortedChainStarts = _.sortBy(chainStarts, [
            item => item.donor.cluster.clusterStatusId,
            item => commentSortGroup(item.donor.cluster.note),
            item => surgeryDateSortValue(item),
            item => parseInt(item.donor.minWeeksUntilTransplant),
            item => item.donor.alias
        ]);

        return sortedChainStarts;
    }

    getConfigData = () => {
        let {
            matchRunType, maxChainDepth, maxLoopDepth, isolateDeepestN, veryLowPmp, lowPmp, hlaFloorForAccumulator,
            bufferDonorAgeByYears, bufferHlaMatchPointsByPoints, useOnlyPreAcceptedDonors, useAllCHIPS, onlyOToO, ignoreBlockAllDonors, returnOnlyOBDs, endOnAboO
        } = this.state;

        let configData = {
            matchRunType, maxChainDepth, maxLoopDepth, isolateDeepestN, veryLowPmp, lowPmp, hlaFloorForAccumulator, bufferDonorAgeByYears,
            bufferHlaMatchPointsByPoints, useOnlyPreAcceptedDonors,
            useAllCHIPS, onlyOToO, ignoreBlockAllDonors, returnOnlyOBDs, endOnAboO
        };

        return configData;
    }

    handleSuppress = () => {
        let suppress = !this.state.suppress;
        let { checkType } = this.state.scenario.group;

        let statusThreshold = checkType == TargetCheckTypeNew.HardToMatch
            ? ClusterStatus.Logistics
            : ClusterStatus.Offers;

        let chainStarts = _.cloneDeep(this.state.chainStarts).map(cs => ({
            ...cs,
            selected: suppress && cs.donor.cluster.clusterStatusId > statusThreshold
                ? false
                : cs.selected
        }));

        this.setState({ suppress, chainStarts });
    }

    handleCheckStalled = () => {
        let chainStarts = _.cloneDeep(this.state.chainStarts).map(cs => {
            if (cs.donor.cluster.clusterStatusId == ClusterStatus.Stalled && cs.donor.cluster.note.toUpperCase() == 'OFFER') {
                cs.selected = true;
            }

            return cs;
        });

        this.setState({
            chainStarts
        });
    }

    handleCheckAllChainStarts = () => {
        let { checkType } = this.state.scenario.group;
        let { suppress, checkAllChainStarts } = this.state;
        let isHardToMatch = checkType == TargetCheckTypeNew.HardToMatch;

        let statusThreshold = isHardToMatch
            ? ClusterStatus.Logistics
            : ClusterStatus.Offers;

        let chainStarts = _.cloneDeep(this.state.chainStarts).map(cs => {
            let isPastThreshold = cs.donor.cluster.clusterStatusId > statusThreshold;

            let selected = (isHardToMatch && isPastThreshold)
                ? cs.selected
                : (isPastThreshold && suppress)
                    ? cs.selected
                    : !checkAllChainStarts;

            return { ...cs, selected };
        });

        this.setState({ chainStarts, checkAllChainStarts: !checkAllChainStarts });
    }

    handleCheckAllCenters = () => {
        let centerList = _.cloneDeep(this.state.centerList).map(item => {
            item.selected = !this.state.checkAllCenters
            return item;
        });

        this.setState({
            centerList,
            checkAllCenters: !this.state.checkAllCenters
        });
    }

    handleConfigValueChange = (property: string, value: any) => {
        var state = _.cloneDeep(this.state);

        if (property == 'maxChainDepth') {
            state.maxChainDepth = parseInt(value);
        }

        if (property == 'maxLoopDepth') {
            state.maxLoopDepth = parseInt(value);
        }

        if (property == 'onlyOToO') {
            state.onlyOToO = value == 'true';
        }

        if (property == 'returnOnlyOBDs') {
            state.returnOnlyOBDs = !state.returnOnlyOBDs;
        }

        this.setState(state);
    }

    handleChainStartSelect = (id: number) => {
        var chainStarts = _.cloneDeep(this.state.chainStarts).map(cs => {
            if (cs.donor.id == id) {
                cs.selected = !cs.selected;
            }

            return cs;
        });

        this.setState({
            chainStarts
        });
    }

    handleCenterSelect = (centerId: number) => {
        let centerList = _.cloneDeep(this.state.centerList).map(item => {
            if (item.center.id == centerId) {
                item.selected = !item.selected;
            }

            return item;
        });

        this.setState({
            centerList
        });
    }

    handleSubmitMatchRun = (restricted: boolean, runAllHardToMatch: boolean = false) => {
        let {
            matchRunType,
            bufferDonorAgeByYears: bufferDonorAgeByYearsVal,
            bufferHlaMatchPointsByPoints: bufferHlaMatchPointsVal,
            useOnlyPreAcceptedDonors: onlyPreAcceptedOneWaysVal,
            useAllCHIPS: chipsIfFncs3IsLessThan1Val,
            onlyOToO: onlyOtoOVal,
            endOnAboO,
            maxChainDepth: maxChainDepthVal,
            maxLoopDepth: maxLoopDepthVal,
            isolateDeepestN: isolateDeepestNVal,
            veryLowPmp: veryLowPmpVal,
            lowPmp: lowPmpVal,
            hlaFloorForAccumulator: cumulativeHlaPointsFloorVal,
            returnOnlyOBDs: onlyOBds,
            ignoreBlockAllDonors: ignoreBlockAllDonorsVal,
            chainStarts: chainStartList,
            centerList,
            targets,
            scenario
        } = this.state;

        let chainStarts = chainStartList.filter(x => x.selected).map(x => x.donor.id);

        if (runAllHardToMatch) {
            chainStarts = chainStartList.filter(x => x.donor.cluster.clusterStatusId < ClusterStatus.InProcess).map(x => x.donor.id);
        }

        let centers = centerList.filter(x => x.selected).map(x => x.center.id);

        if (restricted) {
            onlyPreAcceptedOneWaysVal = true;
        } else {
            onlyPreAcceptedOneWaysVal = false;
        }

        let diagnosticsData = JSON.parse(localStorage.getItem('bm-diagnostics-' + this.state.uuid));

        let request: IMatchRunRequest = {
            matchRunType,
            settings: {
                bufferDonorAgeByYearsVal, bufferHlaMatchPointsVal, onlyPreAcceptedOneWaysVal, ignoreBlockAllDonorsVal,
                chipsIfFncs3IsLessThan1Val, onlyOtoOVal, maxChainDepthVal, maxNumberOfClustersVal: 0,
                maxLoopDepthVal, isolateDeepestNVal, veryLowPmpVal, lowPmpVal,
                cumulativeHlaPointsFloorVal, onlyOBds, endOnAboO,
                scenario: scenario != null ? scenario.id : 0,
                chainStarts, centers, targetChainEnds: targets.map(x => x.recipientId),
                isFutureScenario: scenario.group.future
            },
            diagnosticsData
        };

        this.props.showLoading('Starting run...').then(() => {
            this.props.submitMatchRun(request).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    let url = '/matching/results-new/' + response.data.results;

                    if (this.state.scenario != null) {
                        if (this.state.scenario.submit) {
                            window.location.href = url + '?scenario=' + this.state.scenario.id;
                        } else {
                            let results = window.open(url + '?scenario=' + this.state.scenario.id, '_blank');
                            results.focus();
                        }
                    } else {
                        let results = window.open(url, '_blank');
                        results.focus();
                    }
                }
            })
        });
    }

    handleClusterStatusChange = (clusterId: number, clusterStatus: number) => {
        this.props.showLoading('Updating cluster status, one moment please...').then(() => {
            this.props.saveClusterStatus(clusterId, clusterStatus).then((response: IBaseResponse) => {
                if (response.data.success)
                    this.getData();
            });
        });
    }

    handleSaveComment = (clusterId: number, comment: string) => {
        this.props.saveComment(clusterId, comment).then((response: IBaseResponse) => {
            if (response.data.success)
                this.getData();
        });
    }


    handleReturnToTargetsPage = () => {
        window.location.href = '/target-new';
    }

    handleShowEwt = (ewtSummary: IEwtSummary, initialCount: any) => {
        this.setState({
            ewt: {
                show: true,
                ewtSummary,
                initialCount
            }
        });
    }

    handleEwtClose = () => {
        this.setState({
            ewt: {
                show: false,
                ewtSummary: null,
                initialCount: null
            }
        });
    };

    getTargetListType = (scenario: IMatchRunScenario): ListType => {
        if (scenario == null || scenario.submit || scenario.group.stalled) {
            return null;
        }

        switch (scenario.group.checkType) {
            case TargetCheckTypeNew.HardToMatch:
                return ListType.HardToMatch;
            case TargetCheckTypeNew.Compatible:
            case TargetCheckTypeNew.Special:
            case TargetCheckTypeNew.Regular:
                return ListType.Vouchers;
            default:
                return null;
        }
    }

    getTargetList = (type: ListType, targets: IMiracleMatch[], results: IGetAllNewResponse['data']['results']): ITargetItem[] => {
        let targetIds = targets.map(x => x.recipientId);

        let primaryList = type == ListType.HardToMatch ? results.hardToMatchList : results.voucherList;

        let allTargets = _.uniqBy([...primaryList, ...results.hardToMatchList, ...results.voucherList, ...results.pairedPatientList], x => x.recipientId);

        return allTargets.filter(x => targetIds.indexOf(x.recipientId) > -1);
    }

    handleShowMortalityBreakdown = (type: number, recipient: ITargetItem) => {
        this.setState({
            mortalityBreakdown: {
                show: true,
                recipientAlias: recipient.recipientAlias,
                data: recipient.mortalityCalculations
            }
        });
    }

    handleMortalityBreakdownClose = () => {
        this.setState({
            mortalityBreakdown: {
                show: false,
                recipientAlias: '',
                data: null
            }
        });
    }

    getIsManualHardToMatch = () => {
        if (this.state.scenario != null) {
            return this.state.scenario.submit == false && this.state.scenario.group.checkType == TargetCheckTypeNew.HardToMatch;
        }

        return false;
    }

    render() {
        const sortedChainStarts = this.getChainStarts();

        const selectedChainStartCount = this.state.chainStarts.filter(x => x.selected).length;

        const disableSubmit =
            (this.state.matchRunType == MatchRunType.Chains && selectedChainStartCount == 0)
            || (this.state.matchRunType == MatchRunType.Loops && selectedChainStartCount > 0);

        const configData = this.getConfigData();

        // const clusterStatusList: IListItem[] = [
        //     { id: 0, description: 'All', abbreviation: '' },
        //     { id: 1, description: 'Stalled', abbreviation: '' },
        //     { id: 2, description: 'Offers', abbreviation: '' },
        //     { id: 3, description: 'Donor Clearance', abbreviation: '' },
        //     { id: 4, description: 'Kickoff', abbreviation: '' },
        //     { id: 5, description: 'No Match', abbreviation: '' },
        //     { id: 6, description: 'XPlanted', abbreviation: '' },
        //     { id: 7, description: 'Logistics', abbreviation: '' },
        //     { id: 8, description: 'In-Process', abbreviation: '' },
        //     { id: 10, description: 'ID', abbreviation: '' },
        // ];

        console.log(this.state.clusterStatusList)

        const filteredClusterStatusList = this.state.clusterStatusList.filter(x => x.id != ClusterStatus.KflId);
        const currentScenario = this.state.scenario ?? { stalled: false };

        return (
            <>
                <MatchSetupWrapper className='container'>
                    {this.state.noSelected && (
                        <Alert bsStyle='danger' style={{ textAlign: 'center', paddingTop: 7.5, paddingBottom: 7.5 }}>
                            No available chain starters found... This usually occurs when the manage swaps page comments are not updated, or appropriate swaps are not cancelled.
                            {this.state.scenario.id != this.state.originalScenario.id && (
                                <>
                                    <br />
                                    The scenario has been changed from <strong>{this.state.originalScenario.group.name} {this.state.originalScenario.title}</strong> to <strong>{this.state.scenario.group.name} {this.state.scenario.title}</strong>.
                                </>
                            )}
                        </Alert>
                    )}

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        <div style={{ fontSize: 28, fontWeight: 500 }}>Match Run Setup</div>
                        <div style={{ textAlign: 'center' }}>
                            {this.state.scenario != null && (
                                <div className={this.state.scenario.group.cssClass}><Label style={{ fontSize: '100%' }}>{this.state.scenario.group.name} {this.state.scenario.title}</Label></div>
                            )}
                        </div>
                        <div>
                            <a href='/matching/match-run/list/new'>Return to Match Run List</a>
                        </div>
                    </div>

                    <Config
                        data={configData}
                        targets={this.state.targetList}
                        targetListType={this.state.targetListType}
                        onChange={this.handleConfigValueChange}
                        onShowEwt={this.handleShowEwt}
                        onShowMortalityBreakdown={this.handleShowMortalityBreakdown}
                    />

                    <Row style={{ marginBottom: 5 }}>
                        <Col xs={12} lg={12}>
                            <ChainStarts
                                suppress={this.state.suppress}
                                checkAllChainStarts={this.state.checkAllChainStarts}
                                sortedChainStarts={sortedChainStarts}
                                clusterStatusList={filteredClusterStatusList}
                                scenario={currentScenario}
                                onClusterStatusChange={this.handleClusterStatusChange}
                                onSuppress={this.handleSuppress}
                                onCheckStalled={this.handleCheckStalled}
                                onCheckAllChainStarts={this.handleCheckAllChainStarts}
                                onChainStartSelect={this.handleChainStartSelect}
                                onCommentChange={this.handleSaveComment}
                            />
                        </Col>
                    </Row>

                    <Row style={{ marginBottom: 5 }}>
                        <Col xs={12}>
                            <div style={{ textAlign: 'right' }}>
                                <Button bsStyle='primary' style={{ marginRight: 5 }} disabled={disableSubmit} title='Block Non-Preselected Donors' onClick={() => this.handleSubmitMatchRun(true)}>Submit Match Run - Restricted</Button>
                                <Button bsStyle='primary' style={{ marginRight: 5 }} disabled={disableSubmit} title='Ignore Block Non-Preselected Donors' onClick={() => this.handleSubmitMatchRun(false)}>Submit Match Run - Unrestricted</Button>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} lg={12}>
                            <Centers
                                checkAllCenters={this.state.checkAllCenters}
                                centerList={this.state.centerList}
                                onCheckAllCenters={this.handleCheckAllCenters}
                                onCenterSelect={this.handleCenterSelect}
                            />
                        </Col>
                    </Row>
                </MatchSetupWrapper>

                <EwtDetails
                    show={this.state.ewt.show}
                    summaryData={this.state.ewt.ewtSummary}
                    initialCount={this.state.ewt.initialCount}
                    donorsPerMonthByAbo={this.state.donorsPerMonthByAbo}
                    onClose={this.handleEwtClose}
                />

                <MortalityBreakdown
                    show={this.state.mortalityBreakdown.show}
                    recipientAlias={this.state.mortalityBreakdown.recipientAlias}
                    data={this.state.mortalityBreakdown.data}
                    onClose={this.handleMortalityBreakdownClose}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        clusterStatusList: state.swaps.clusterStatusList
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        configureMatchRun: (targets, chainEndTargets) => {
            return dispatch(MatchingActionCreators.configureMatchRunNew(targets, chainEndTargets));
        },
        submitMatchRun: (request) => {
            return dispatch(MatchingActionCreators.submitMatchRunNew(request));
        },
        getDonorsPerMonthByAbo: () => {
            return dispatch(TargetActionCreators.getDonorsPerMonthByAbo());
        },
        getAllTargets: () => {
            return dispatch(TargetActionCreators.getAllNew());
        },
        saveClusterStatus: (clusterId, clusterStatus) => {
            return dispatch(SwapActionCreators.saveClusterStatus(clusterId, clusterStatus));
        },
        saveComment: (clusterId, comment) => {
            return dispatch(SwapActionCreators.saveComment(clusterId, comment));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(ConfigureMatchRun);